define(function(require, exports, module) {
    var app = require('Cloud/Application/app');
    var $ = require('jquery');
    var escapeForHTML = require('lib/escapeForHtml');
    var Toolkit = require('./Toolkit');
    var _fest = require('fest/app.xml');

    window.fest.app = _fest;

    Toolkit.init();

    var appTemplate = _fest;

    fest.app = function(ctx) {
        var html;

        html = appTemplate(extendData(ctx));

        return html;
    };

    var extendData = function(data) {
        data.params = $.extend({}, data.params || {}, app.allParams(), {
            ui: app.user.allUIParams(),

            SHARED: app.isShared(),
            SHARED_INCOMING: app.isSharedIncoming(),
            SHARED_LINKS: app.isSharedLinks(),
            LINKS: app.isLinks(),
            HOME: app.isHome(),
            FAVORITES: app.isFavorites(),
            PUBLIC: app.isPublic(),
        });

        return data;
    };

    fest[''] = fest.app;

    $.fest = function(url, data, callback) {
        data = extendData(data);

        var html = fest.app(data);

        callback && callback(html);

        return html;
    };

    module.exports = {
        escapeHTML: escapeForHTML,
    };
});
